import { Collapse, List, ListItem, ListItemIcon, ListItemText, Theme, createStyles, makeStyles } from '@material-ui/core';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import SearchService from '../services/search.service';
import { SystemValues } from '../store/models/systemValues.model';
import LogoComponent from './employee/logo.component';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '100%',
            maxWidth: 660,
            backgroundColor: theme.palette.background.paper,
        },
        nested: {
            paddingLeft: theme.spacing(4),
            whiteSpace: 'pre-wrap'
        },
    }),
);

const Home: React.FC = () => {
    const history = useHistory();
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [openBefore, setOpenBefore] = useState(false);
    const [openFAQ, setOpenFAQ] = useState(false);
    /* const [accreditation, setAccreditation] = useState<string>()
    const [faq, setFaq] = useState<string>()
    const [beforeStart, setBeforeStart] = useState<string>() */
    const [systemValues, setSystemValues] = useState<SystemValues>();

    useEffect(() => {
        /*  RemarksService.getRemarks().then(data => {
             data.map(i => {
                 setAccreditation(i.accreditation)
                 setFaq(i.faq)
                 setBeforeStart(i.beforeStart)
             })
         }) */
        SearchService.getSystemValues().then(result => {
            setSystemValues(result)
            sessionStorage.setItem("SystemValues", JSON.stringify(result))
        }).catch((ex: any) => { console.log(ex.message) })
    }, [])

    const handleClick = () => {
        setOpen(!open);
    };
    const handleClickBefore = () => {
        setOpenBefore(!openBefore);
    };
    const handleClickFAQ = () => {
        setOpenFAQ(!openFAQ);
    };


    return (

        <div>
            <LogoComponent />
            <ul style={{ listStyle: 'none' }}>
                <li>A persons acceditation test details can be checked at no cost through this portal.</li>
                <br />
                <li>The portal will display the expiry date of each accreditation test</li>
                <li>This takes about 1 min</li>
                <br />
                <br />
                <li><button onClick={() => { history.push('/search') }}>Check details</button></li>
            </ul>

            <List
                component="nav"
                aria-labelledby="nested-list-subheader"
                className={classes.root}
            >
                <ListItem button onClick={handleClick}>
                    <ListItemIcon>
                        {open ? <RemoveCircleIcon /> : <AddCircleIcon />}
                    </ListItemIcon>
                    <ListItemText primary="Historic Accreditation Records" />
                </ListItem>
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <ListItem button className={classes.nested}>
                            <ListItemText primary={systemValues && systemValues.portalInfo1} />
                        </ListItem>
                    </List>
                </Collapse>
                <ListItem button onClick={handleClickBefore}>
                    <ListItemIcon>
                        {openBefore ? <RemoveCircleIcon /> : <AddCircleIcon />}
                    </ListItemIcon>
                    <ListItemText primary="Before you start" />
                </ListItem>
                <Collapse in={openBefore} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <ListItem button className={classes.nested}>
                            <ListItemText primary={systemValues && systemValues.portalInfo2} />
                        </ListItem>
                    </List>
                </Collapse>
                <ListItem button onClick={handleClickFAQ}>
                    <ListItemIcon>
                        {openFAQ ? <RemoveCircleIcon /> : <AddCircleIcon />}
                    </ListItemIcon>
                    <ListItemText primary="FAQ" />
                </ListItem>
                <Collapse in={openFAQ} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <ListItem button className={classes.nested}>
                            <ListItemText primary={systemValues && systemValues.portalInfo3} />
                        </ListItem>
                    </List>
                </Collapse>
            </List>
        </div>
    );
};

export default Home;



